module.exports = __webpack_public_path__ + "img/pixnet_logo_dark.2e5cb29.svg";